
export const isAuthenticated  = () => localStorage.getItem('@ValorizaENG-Admin-Token') !== null

export const getToken = () => localStorage.getItem('@ValorizaENG-Admin-Token')

export const setToken = token => {
    localStorage.setItem('@ValorizaENG-Admin-Token', token)
}

export const deleteToken = () => {
    localStorage.removeItem('@ValorizaENG-Admin-Token')
}

